import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFolderDatabase';
/** Renders an SVG icon. */
const SvgFolderDatabase = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M4 23a3 3 0 0 0 3 3h6a1 1 0 1 0 0-2H7a1 1 0 0 1-1-1V10h17a1 1 0 0 1 1 1v2a1 1 0 1 0 2 0v-2a3 3 0 0 0-3-3h-5.635a1 1 0 0 0-.106-.15l-2.7-3.152A2 2 0 0 0 13.04 4H6a2 2 0 0 0-2 2zm9.04-17 1.715 2H6V6z"
      />
      <path
        fill="currentColor"
        d="M17 18a1 1 0 1 1 2 0v7.034q.017.019.05.046c.147.12.427.277.88.43.9.303 2.186.49 3.57.49s2.67-.187 3.57-.49c.453-.153.733-.31.88-.43q.032-.027.05-.046V18a1 1 0 1 1 2 0v7.148c0 .668-.396 1.165-.788 1.484-.4.326-.926.578-1.504.773-1.163.392-2.675.595-4.208.595-1.532 0-3.045-.203-4.208-.595-.578-.195-1.103-.447-1.504-.773-.392-.32-.788-.816-.788-1.485z"
      />
      <path
        fill="currentColor"
        d="M23.5 15c1.604 0 3.1.234 4.23.646.562.204 1.087.47 1.49.817.4.343.78.86.78 1.537s-.38 1.194-.78 1.537c-.403.347-.928.613-1.49.818-1.13.41-2.626.645-4.23.645s-3.1-.234-4.23-.645c-.562-.205-1.087-.471-1.49-.818-.4-.343-.78-.86-.78-1.537s.38-1.194.78-1.537c.403-.347.928-.613 1.49-.818 1.13-.41 2.626-.645 4.23-.645m0 2c-1.433 0-2.687.213-3.547.525-.434.158-.715.322-.869.455q-.012.01-.021.02.009.01.021.02c.154.133.435.297.87.455.859.312 2.113.525 3.546.525s2.687-.213 3.547-.525c.434-.158.715-.322.869-.455q.011-.01.02-.02-.009-.01-.02-.02c-.154-.133-.435-.297-.87-.455-.859-.312-2.113-.525-3.546-.525"
      />
      <path
        fill="currentColor"
        d="M29 21a1 1 0 0 1 1 1c0 .717-.511 1.173-.87 1.41-.397.261-.912.461-1.478.615-1.142.312-2.634.475-4.152.475s-3.01-.163-4.152-.475c-.566-.154-1.08-.354-1.479-.616C17.511 23.173 17 22.717 17 22a1 1 0 0 1 1.963-.265l.006.004c.15.099.44.23.905.357.921.25 2.226.404 3.626.404s2.705-.153 3.626-.404c.466-.127.756-.258.905-.357q.003-.001.005-.004A1 1 0 0 1 29 21"
      />
    </svg>
  );
};
SvgFolderDatabase.displayName = displayName;
export default SvgFolderDatabase;
